import * as api from '@api';
import RefreshToken from '@views/refresh-token';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { shallow } from 'zustand/shallow';
import { useAuth } from '@/state/auth';

const RenewingToken = ({ token }) => {
  const navigate = useNavigate();
  const { logout, accessTokenReceived, sessionExpired } = useAuth(
    state => ({
      logout: state.logout,
      accessTokenReceived: state.accessTokenReceived,
      sessionExpired: state.sessionExpired,
    }),
    shallow,
  );

  useEffect(() => {
    api.backend.refreshToken(token).then(response => {
      if (response.status === 200) {
        setTimeout(() => {
          accessTokenReceived(response.data.accessToken, response.data.user);
        }, 750);
      } else if (response.status === 419 || response.status === 401) {
        setTimeout(() => {
          sessionExpired();
          logout();
        }, 750);
      } else {
        logout();
        navigate('/login');
      }
    });
  }, []);

  return <RefreshToken />;
};
export default RenewingToken;
